let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jHACf")).then(() => parcelRequire('blZ2O'));